import { Arrow } from '@public';
import { ConnectedDeviceSummary, DeviceSummary } from '@types';
import { convertDateAndTimeToDisplayFormat, toSentenceCase } from '@utils';

import styles from './deviceItem.module.scss';

export interface DeviceItemProps {
	device: DeviceSummary | ConnectedDeviceSummary;
	onItemClick: (device: DeviceSummary | ConnectedDeviceSummary) => void;
	selected: boolean;
	isNested?: boolean;
}

export const DeviceItem = ({ device, onItemClick, selected, isNested }: DeviceItemProps) => {
	const { displayName, deviceStatus, make, model, reference, lastReadingDate } = device;

	return (
		<tr
			className={[
				styles.container,
				selected && styles['container-selected'],
				isNested && styles['container-nested'],
			].join(' ')}
			onClick={() => {
				onItemClick(device);
			}}
			role="row"
		>
			<td role="rowheader">{displayName ? displayName : reference}</td>
			<td>
				{make} {model}
			</td>
			<td>{toSentenceCase(deviceStatus as string)}</td>
			<td>{lastReadingDate ? convertDateAndTimeToDisplayFormat(lastReadingDate) : '-'}</td>
			<td>
				<button
					className={styles.arrow}
					aria-label={['Select ', { displayName }].join(' ')}
					tabIndex={0}
					onClick={() => {
						onItemClick(device);
					}}
				>
					<Arrow customStyles={styles.arrow} />
				</button>
			</td>
		</tr>
	);
};
